import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { settings, handleChange } = this.props;

        return (
            <div>
                <h3>{translate.gettext('Filter')}</h3>

                <NodeSystemFilterEditor {...this.props} />
                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext('Columns')}</h3>
                <CheckboxInput
                    label={translate.gettext('Alert duration')}
                    name="displayAlertDuration"
                    checked={settings.displayAlertDuration}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext('OK duration')}
                    name="displayOkDuration"
                    checked={settings.displayOkDuration}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext('Distribution over timespan')}
                    name="displayDayDistribution"
                    checked={settings.displayDayDistribution}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext('Alert duration in percent')}
                    name="displayAlertPercentage"
                    checked={settings.displayAlertPercentage}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext('OK duration in percent')}
                    name="displayOkPercentage"
                    checked={settings.displayOkPercentage}
                    onChange={this.handleChange.bind(this)} />

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlertSummary/Editor.tsx